<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-data-table :headers="meshHeaders" :items="meshData" :items-per-page="15" class="elevation-1"></v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  computed: {
    meshHeaders() {
      return this.$store.getters.meshHeaders
    },
    meshData() {
      return this.$store.getters.meshData
    }
  },
  data() {
    return {
      localMeshHeaders: [],
      localMeshData: []
    };
  },
  methods: {
    fetchMeshdata: function() {
      window.console.log("CALL FETCH MESHDATA");
      const me = this;
      const url = "https://www.meshstats.net/bus_simulator/busapi.php";
      let params = {
        latitude: 34.9973787377006,
        longitude: 135.780029296875,
        distance: 10
      };
      axios
        .get(url, { params })
        .then(function(response) {
          me.parseContent(response.data);
        })
        .catch(function(error) {
          window.console.error(error);
        })
        .finally(function() {});
    },
    parseContent(content) {
      let lines = content.split(/\r\n|\r|\n/).map(line => line.split(/,|\t/));
      let headers = lines.splice(0, 1)[0];
      this.localMeshHeaders = headers.map((header) => {
        return { text: header, value: header };
      });
      this.localMeshData = lines.map(line => {
        let data = {}
        line.forEach((element, index) => {
          data[headers[index]] = element
        });
        return data;
      } );
    }
  }
};
</script>
